import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';

export class FileService {
  static async upload(formData: FormData): Promise<{ paths: string[] }> {
    const response: AxiosResponse<{ paths: string[] }> = await AxiosService.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  static async remove(fileName: string): Promise<void> {
    await AxiosService.delete(`/upload/${fileName}`);
  }
}